import { render, staticRenderFns } from "./ShopOrder.vue?vue&type=template&id=337aa5e8"
import script from "./ShopOrder.vue?vue&type=script&lang=js"
export * from "./ShopOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports